"use client";

import Link from "next/link";
import { useParams } from "next/navigation";

export default function YearChildCompLink({ href, children, ...rest }: Parameters<typeof Link>[0]) {
  const { year } = useParams();
  const ALLYear = ["2025", "2024", "2023", "2022"] as const;
  const yearComp = ALLYear.find((f) => f === year) || ALLYear[0];

  return (
    <Link href={`/${yearComp}/${href}`} {...rest}>
      {children}
    </Link>
  );
}
